export const getCreateSiteMaterialUrl = (tradeCompanyId: number): string => {
  return `/ground-control/v2/manage-company/${tradeCompanyId}/site-materials/new/`;
};
